import { BankInstitution } from './../../../shared/models/bank-institution.model';
import { MdDialog, MdDialogConfig, MdDialogRef } from '@angular/material';
import { OnInit } from '@angular/core/';
import { Component, Input, OnChanges, ViewContainerRef } from '@angular/core';

import { BankAccount } from 'app/shared/models/bank-account.model';
import { EntityCafService } from 'app/entities/caf/entity-caf.service';
import { BankAccountComponent } from 'app/entities/finance/bankaccount/bank-account.component';

@Component({
    selector: 'bank-details',
    templateUrl: './bank-details.component.html'
})
export class BankDetailsComponent implements OnChanges {
    @Input() entityId: number;
    bankInstitutions: Array<BankInstitution>;
    dialogRef: MdDialogRef<any>;

    constructor(private cafService: EntityCafService,
        private dialog: MdDialog,
        private viewContainerRef: ViewContainerRef) { }

    ngOnChanges() {
        if (this.entityId) {
            this.loadBankAccounts();
        }
    }

    loadBankAccounts() {
        this.cafService.getBankAccountsForEntity(this.entityId).subscribe(response => {
          //TODO: remove this after test server check
          console.log('banck account list: ', response);
            this.bankInstitutions = response;
        });
    }

    openAddBankAccountsDialog() {
        const config = new MdDialogConfig();
        config.disableClose = true;
        config.viewContainerRef = this.viewContainerRef;

        this.dialogRef = this.dialog.open(BankAccountComponent, config);
        this.dialogRef.componentInstance.action = 'Add';
        this.dialogRef.afterClosed().subscribe(result => {
            this.dialogRef = null;
            if (result) {
                this.loadBankAccounts();
            }
        });
    }

    editBankAccount(account: BankAccount, bank: BankInstitution): void {
        const action = 'Edit';
        const config = new MdDialogConfig();
        config.disableClose = true;
        config.viewContainerRef = this.viewContainerRef;

        this.dialogRef = this.dialog.open(BankAccountComponent, config);
        this.dialogRef.componentInstance.selectedBankAccount = account;
        this.dialogRef.componentInstance.bankInstitution = bank;
        this.dialogRef.componentInstance.action = action;
        this.dialogRef.afterClosed().subscribe(response => {
            this.dialogRef = null;
            if (response) {
                this.loadBankAccounts();
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/entities/caf/bankdetails/bank-details.component.ts